(function(){
  const POPUP_DOM_ID = 'popup-geo-redirect';
  const STORAGE_ID = 'bayard-sg-georedirect-trigger';
  const PROMPT_TRIGGER_DELAY = 24 * 60 * 60 * 1000; // 1 day
  // const PROMPT_TRIGGER_DELAY = 15000;
  const COUNTRY_LIST = ['UK'];

  let releaseTrapFocus = null;

  window.addEventListener('load', () => {
    init();
  });

  function init(){
    const root = getPopupRoot();
    if(!root) throw new Error('Geolocation redirect nodes not found in DOM');
  
    if(isPreviouslyPrompted()) return;

    runGeoRedirect(() => {
      setupListeners(root);
      togglePopup(true);
    });
  }

  function setupListeners(modalRoot){
    if(!modalRoot) return false;

    const closeButton = modalRoot.querySelector('[data-pgr-close]');
    if(closeButton){
      closeButton.addEventListener('click', () => {
        togglePopup(false);
        setTriggerDelay(PROMPT_TRIGGER_DELAY);
      });
    }

    const redirectLink = modalRoot.querySelector('[data-pgr-redirect]');
    if(redirectLink){
      redirectLink.addEventListener('click', () => {
        togglePopup(false);
        setTriggerDelay(PROMPT_TRIGGER_DELAY)
      });
    }

    const overlay = modalRoot.querySelector('.pgr-modal-overlay');
    if(overlay){
      overlay.addEventListener('click', (e) => {
        if(e.target !== e.currentTarget) return;
        togglePopup(false);
      });
    }
  }

  function trapFocus(modalRoot){
    if(!modalRoot) throw new Error('Element must be provided');

    const prevFocus = document.activeElement;

    const focusableElements = Array.from(modalRoot.querySelectorAll('button, [href], [tabindex]:not([tabindex="-1"]'));
    const first = focusableElements[0];
    const last = focusableElements[focusableElements.length - 1];

    document.addEventListener('keydown', handleKeyDown);
    if(first) first.focus();

    function handleKeyDown(e){
      if((!first || !last) && e.key !== 'Tab') return;

      const current = document.activeElement;
      
      console.log(current === first, current === last);
      // Wrap around focus
      console.log(current === first, current === last);
      if(e.shiftKey && current === first){
        last.focus();
        e.preventDefault();
      }

      if(!e.shiftKey && current === last){
        first.focus();
        e.preventDefault();
      }
    }

    function untrap(){
      if(prevFocus) prevFocus.focus();
      document.removeEventListener('keydown', handleKeyDown);
    }

    return untrap;
  }

  function getPopupRoot(){
    return document.querySelector(`#${POPUP_DOM_ID}`);
  }

  function togglePopup(show){
    const root = getPopupRoot();
    if(!root) return;

    root.classList.toggle('show', show);
    document.body.classList.toggle('popup-noscroll', show);
    document.documentElement?.classList.toggle('scrollbar-stable', show);

    if(show){
      releaseFocusTrap = trapFocus(root.querySelector('.pgr-modal'));
    }else{
      if(releaseFocusTrap) releaseFocusTrap();
    }
  }

  function isPreviouslyPrompted(){
    if(!localStorage) return;

    const strTimestamp = localStorage.getItem(STORAGE_ID);
    if(!strTimestamp) return false;

    try{
      const expiry = parseInt(strTimestamp);
      return expiry > (new Date()).getTime();
    }catch{
      return false;
    }
  }

  function setTriggerDelay(ms){
    if(!localStorage) return;
    const expiry = (new Date()).getTime() + ms;
    localStorage.setItem(STORAGE_ID, expiry);
  }

  async function runGeoRedirect(cb){
    const isInUK = await isInCountryList(COUNTRY_LIST);
    if(!isInUK) cb();
  }

  async function isInCountryList(countryList){
    const res = await fetch('https://ipapi.co/json');
    if(!res.ok) return false;
    const data = await res.json();
    return countryList.includes(data.country);
  }

})();